export default "__VITE_ASSET__CvYlo1Uc__";